/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Noeventsyet2Inputs */

const en_noeventsyet2 = /** @type {(inputs: Noeventsyet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No events yet`)
};

const de_noeventsyet2 = /** @type {(inputs: Noeventsyet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Events`)
};

/**
* | output |
* | --- |
* | "No events yet" |
*
* @param {Noeventsyet2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const noeventsyet2 = /** @type {((inputs?: Noeventsyet2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Noeventsyet2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_noeventsyet2(inputs)
	return de_noeventsyet2(inputs)
});
export { noeventsyet2 as "noEventsYet" }